import React, { Dispatch, SetStateAction, useContext } from "react";
import {
  CLINICIAN_ROLES,
  FEATURES,
  FilterDataType,
  USER_TYPE,
} from "@home-health-notify/domain";
import {
  getFilteredUserTypes,
  IOrganizationContext,
  OrganizationContext,
} from "hhn-commons";
import UserRoleFilters from "./UserRoleFilters";
import UserTypeFilters from "./UserTypeFilters";

export interface UserDirectoryFilterProps {
  departments: CLINICIAN_ROLES[];
  filterData: FilterDataType;
  setFilterData: Dispatch<SetStateAction<FilterDataType>>;
  currentUserTypes?: USER_TYPE[];
}

const UserDirectoryFilter = ({
  departments,
  filterData,
  setFilterData,
  currentUserTypes = [],
}: UserDirectoryFilterProps) => {
  const { selectedOrgUser }: IOrganizationContext =
    useContext(OrganizationContext);
  const loggedInUserType =
    selectedOrgUser?.getOrganization()?.userProfile?.type ?? USER_TYPE.USER;

  const canAddExternalUsers =
    selectedOrgUser?.hasAccess(FEATURES.ADD_EXTERNAL_USER_IN_PATIENT_GROUP) ??
    false;
  const filteredUserTypes = getFilteredUserTypes(
    canAddExternalUsers,
    loggedInUserType,
  );

  const filteredTypes =
    currentUserTypes.length > 0
      ? filteredUserTypes?.filter(userType =>
          currentUserTypes.includes(userType),
        )
      : filteredUserTypes;

  const onUserTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChangeValue(e, "userType");
  };

  const onUserRoleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChangeValue(e, "userRole");
  };
  const onLabelClick = (
    value: string | USER_TYPE,
    filterDataKey: keyof FilterDataType,
  ) => {
    const isChecked = (
      filterData[filterDataKey] as Array<string | USER_TYPE>
    ).includes(value);
    onChangeValue(
      {
        target: {
          value,
          checked: !isChecked,
        },
      } as React.ChangeEvent<HTMLInputElement>,
      filterDataKey,
    );
  };

  const onChangeValue = (
    e: React.ChangeEvent<HTMLInputElement>,
    filterDataKey: keyof FilterDataType,
  ) => {
    let clonedUserTypeFilterData = [...filterData[filterDataKey]];
    const value = e.target.value;
    if (e.target.checked) {
      clonedUserTypeFilterData.push(value as CLINICIAN_ROLES | USER_TYPE);
    } else {
      clonedUserTypeFilterData = clonedUserTypeFilterData.filter(
        data => data !== value,
      );
    }
    setFilterData({
      ...filterData,
      [filterDataKey]: clonedUserTypeFilterData,
    });
  };

  return (
    <>
      <UserRoleFilters
        departments={departments}
        filterData={filterData}
        onUserRoleChange={onUserRoleChange}
        onLabelClick={onLabelClick}
      />
      <UserTypeFilters
        filteredUserTypes={filteredTypes}
        filterData={filterData}
        onUserTypeChange={onUserTypeChange}
        onLabelClick={onLabelClick}
      />
    </>
  );
};
export default UserDirectoryFilter;
